export default {
  sm: `
  자연을 지키는 기술과<br>사람을 돌보는 에너지
  `,
};
